import './IconMail.css';
import React from 'react';
import { styled } from 'linaria/lib/react';
const IconMail = _ref => {
  let {
    width = 67,
    height = 57.651,
    className,
    fill
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 67 57.651",
    className: className
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector_Stroke_",
    "data-name": "vector (Stroke)",
    d: "M9.462,10.5c-2.119,1.968-3.538,5.16-3.538,10.168V42.483c0,5.008,1.419,8.2,3.538,10.168,2.15,2,5.39,3.076,9.706,3.076H50.331c4.316,0,7.556-1.079,9.706-3.076,2.119-1.968,3.538-5.16,3.538-10.168V20.669c0-5.008-1.419-8.2-3.538-10.168-2.151-2-5.39-3.076-9.706-3.076H19.169C14.852,7.424,11.613,8.5,9.462,10.5ZM6.282,7.075c3.3-3.067,7.854-4.325,12.887-4.325H50.331c5.033,0,9.584,1.258,12.887,4.325,3.335,3.1,5.032,7.695,5.032,13.594V42.483c0,5.9-1.7,10.5-5.032,13.594-3.3,3.067-7.854,4.325-12.887,4.325H19.169c-5.033,0-9.584-1.258-12.887-4.325C2.947,52.98,1.25,48.382,1.25,42.483V20.669C1.25,14.77,2.947,10.171,6.282,7.075Z",
    transform: "translate(-1.25 -2.75)",
    fill: "#0b608a",
    "fill-rule": "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_Stroke__2",
    "data-name": "vector (Stroke)_2",
    d: "M50.632,7.938a2.39,2.39,0,0,1-.418,3.316l-17.2,13.511a8.419,8.419,0,0,1-10.428,0L5.384,11.254a2.39,2.39,0,0,1-.418-3.316,2.3,2.3,0,0,1,3.262-.425l17.2,13.511a3.826,3.826,0,0,0,4.74,0L47.37,7.512A2.3,2.3,0,0,1,50.632,7.938Z",
    transform: "translate(5.701 6.207)",
    fill: "#0b608a",
    "fill-rule": "evenodd"
  }));
};
const StyledSVG = /*#__PURE__*/styled("svg")({
  name: "StyledSVG",
  class: "s1hz28t6"
});
export default IconMail;